import React from 'react'
import {IconProps, IconWrapper} from './IconWrapper'

const renderIcon = (color: string = "#009AEF") => (
    <>
        <path
            d="M15.5 16.7514V16.7998C15.5 17.9199 15.5 18.4804 15.282 18.9082C15.0903 19.2845 14.7845 19.5903 14.4082 19.782C13.9804 20 13.4199 20 12.2998 20H7.6998C6.5797 20 6.02043 20 5.59261 19.782C5.21628 19.5903 4.90952 19.2845 4.71777 18.9082C4.5 18.4808 4.5 17.921 4.5 16.8031V7.19642C4.5 6.07851 4.5 5.51952 4.71777 5.09212C4.90952 4.71579 5.21628 4.40952 5.59261 4.21777C6.02001 4 6.579 4 7.69691 4H12.3031C13.421 4 13.9808 4 14.4082 4.21777C14.7845 4.40952 15.0903 4.71609 15.282 5.09241C15.5 5.52023 15.5 6.0799 15.5 7.2V7.25"
            stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17.5 15L20.5 12M20.5 12L17.5 9M20.5 12H9.5" stroke={color} strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round"/>
    </>
)
export const LogIn: React.FC<IconProps> = ({color, size = 25}) => <IconWrapper {...{
    size,
    color,
    renderIcon,
    viewBox: '0 0 25 24'
}} />
